import React, { useState, useEffect } from "react";
import { Link } from "react-router";
import { useAuth0 } from "@auth0/auth0-react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from "reactstrap";
import useAuthStatus from "../../../../../../common/auth-status";
import Avatar from "../../../../../common/avatar";

const ProfileDropdown = ({ dbUser }) => {
  const { t } = useTranslation();
  const { isAuthenticated, loginWithRedirect, logout } = useAuth0();
  const [authLoading, chapelDbUserLoaded] = useAuthStatus();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [initials, setInitials] = useState("");

  const ready = isAuthenticated && !authLoading;
  const toggle = () => setDropdownOpen(!dropdownOpen);

  const logoutWithRedirect = () => {
    logout({
      returnTo: window.location.origin,
    });
  };

  useEffect(() => {
    if (ready && chapelDbUserLoaded && dbUser) {
      setInitials(
        (dbUser.firstName?.charAt(0) || "") + (dbUser.lastName?.charAt(0) || "")
      );
    }
  }, [ready, chapelDbUserLoaded, dbUser]);

  if (authLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return (
      <Button
        color="link"
        className="nav-link-icon"
        onClick={() => loginWithRedirect({})}
        aria-label={t("login")}
      >
        <i className="fa fa-user-circle" />
        <span>{t("login")}</span>
      </Button>
    );
  }

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle color="link" className="nav-link-icon">
        <i className="fa fa-user-circle" />
        <span>{t("account")}</span>
      </DropdownToggle>
      <DropdownMenu end>
        <DropdownItem header>
          {dbUser?.firstName || ""} {dbUser?.lastName || ""}
        </DropdownItem>
        <DropdownItem tag={Link} to="/account">
          <i className="fa fa-cog me-2" />
          {t("account")}
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem onClick={logoutWithRedirect}>
          <i className="fa fa-sign-out me-2" />
          {t("logout")}
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

const mapStateToProps = (state) => ({
  dbUser: state.user.dbUser,
});

export default connect(mapStateToProps)(ProfileDropdown);
